<style lang="scss" scoped="">
.stateTable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
  //#606672
}
.stateTable /deep/ table {
  border-collapse: collapse;
}
.stateTable /deep/ table tbody tr:first-child {
  height: 42px;
  font-size: 12px;
}
.stateTable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
}
</style>

<template>
  <div ref="container" style="overflow: auto;position: relative">
    <div class="stateTable" v-html="gk"></div>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(store.state.eqPoints[equipment.id][tapCode] && store.state.eqPoints[equipment.id][tapCode].alias)" :visible.sync="isShowDetailDialog" :width="'720px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <technology_detail :equipment="equipment" :tapCode="tapCode"></technology_detail>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import technology_detail from '@@/pages/web/monitor/workshop_ws/equipment/statistics_tabs/technology_detail';
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_equipment_statistics_tabs_working_state',
  components: {
    technology_detail
  },
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tapCode: null
  },
  data() {
    return {
      isShowDetailDialog: false,
      equipmentPoints:{},
    };
  },
  computed: {
    gk() {
      let str = this.tabsData.tab.gk;
      str = this.base64.decode(str);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '');
          c = c.replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '');
          c = c.replace('}', '');

          if (!this.store.state.eqPoints[this.equipment.id][c]) {
            console.log('gongkuangmobanqueshaodian' + ':' + c);
            return;
          }
          let prec = this.equipmentPoints[c].prec;

          if (this.equipmentPoints[c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.equipmentPoints[c].dictTypeCode][parseInt(this.tabsData.eqPoints[c])]));
          } else {
            let dataType = this.equipmentPoints[c].dataType;
            if (dataType == 1) {
              str = str.replace(code, this.tabsData.eqPoints[c]);
            }else if(dataType == 3) {
              str = str.replace(code, isNaN(Number(this.tabsData.eqPoints[c])) ? "" : Number(this.tabsData.eqPoints[c]).toFixed(0));
            }else{
              str = str.replace(code, isNaN(Number(this.tabsData.eqPoints[c])) ? "" : Number(this.tabsData.eqPoints[c]).toFixed(prec == null ? 2 : prec));
            }
          }
        });
      return str;
    }
  },
  created() {
    this.equipmentPoints = this.store.state.eqPoints[this.equipment.id];
  },
  watch: {
    isShowDetailDialog: {
      handler(newValue, oldValue) {
        if (newValue == false) {
          setTimeout(() => {
            this.clearCodeTap();
            this.bindCodeTap();
          }, 100);
        }
      },
      deep: true,
      immediate: true
    },
    tabsData: {
      handler(newValue, oldValue) {
        setTimeout(() => {
          this.clearCodeTap();
          this.bindCodeTap();
        }, 100);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.bindCodeTap();
  },

  destroyed() {
    this.clearCodeTap();
  },
  methods: {
    clearCodeTap() {
      let tables = document.getElementsByClassName('stateTable')[0].getElementsByTagName('table');
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName('tr');

        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName('td');

          for (var k = 0; k < tds.length; k++) {
            if (tds[k].getAttribute('code')) {
              tds[k].removeEventListener('click', this.codeTap, true);
            }
          }
        }
      }
    },
    bindCodeTap() {
      let tables = document.getElementsByClassName('stateTable')[0].getElementsByTagName('table');
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName('tr');

        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName('td');

          for (var k = 0; k < tds.length; k++) {
            if (tds[k].getAttribute('code')) {
              tds[k].removeEventListener('click', this.codeTap, true);
              tds[k].addEventListener('click', this.codeTap, true);
            }
          }
        }
      }
    },
    codeTap(e) {
      if (!e.target.attributes.code.value) {
        return;
      }
      this.tapCode = e.target.attributes.code.value;
      console.log(this.tapCode)
      let point = this.equipmentPoints[this.tapCode]
      console.log(point)
      if(point == null || point.dataType === 1) {
        return;
      }
      this.isShowDetailDialog = true;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.chart) {
          setTimeout(() => {
            //this.initChart()
          }, 100);
        }
      }, 500);
    },
    initChart() {
      this.option = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '30',
          containLabel: true
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },
        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: '#C0C4CC'
          },
          data: ['1#', '2#', '3#', '4#', '5#', '6#', '7#', '8#', '9#', '10#', '11#', '12#', '13#']
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %',
              rotate: 0,
              textStyle: {
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('kaijilv'),
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FD9DFF'
                  },
                  {
                    offset: 1,
                    color: '#4F32FF'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            label: {
              show: false,
              rotate: 0,
              color: '#5C41FF',
              position: 'top',
              fontSize: 12,
              labelFormatter: '{data} %'
            },
            data: [95, 83, 56, 89, 87, 89, 92, 71, 44, , 87, 89, 92, 71, 44],
            barGap: '80%',
            barCategoryGap: '100%'
          },
          {
            name: this.$t('jiadonglv'),
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#6FE5FF'
                  },
                  {
                    offset: 1,
                    color: '#1C70C6'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            label: {
              show: false,
              rotate: 0,
              color: '#419FFF',
              position: 'top',
              fontSize: 12
            },
            data: [89, 71, 60, 32, 34, 74, 52, 46, 26, 34, 74, 52, 46, 26]
          }
        ]
      };
      var chartDom = document.getElementById('chart');
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    }
  }
};
</script>
